import Booking from '../atoms/Booking/booking'
import GroupBooking from '../atoms/GroupBooking/group-booking'

import { BookingCard, GroupBookingCard, BookingListWrapper } from './booking-list-styles'

import { UserBooking } from '../../types/andTypes'

type BookingListProps = {
  bookingList: UserBooking[]
}

const BookingList = ({ bookingList }: BookingListProps) => {
  return (
    <BookingListWrapper>
      {bookingList.map((booking, index: number) =>
        booking.groupId
          ? (
          <GroupBookingCard
            key={booking.date}
            data-selector={`user-booking-card-${index}`}
            data-testid="user-booking-card"
          >
            <GroupBooking userBooking={booking} />
          </GroupBookingCard>
            )
          : (
          <BookingCard
            key={booking.date}
            data-selector={`user-booking-card-${index}`}
            data-testid="user-booking-card"
          >
            <Booking userBooking={booking} />
          </BookingCard>
            )
      )}
    </BookingListWrapper>
  )
}

export default BookingList
